import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
// @ts-ignore
import Calendar from 'react-calendar';
// @ts-ignore
import style from '../strategyProject/tabs/TabResults/TabResults.module.less';
import { useOutsideBounder } from '../../hooks/useOutsideClick';

export default function DateControl(props: DateControlProps){
  const dateRef = useRef<HTMLInputElement>(null)
  useOutsideBounder(dateRef)

  return (
    <div>
      <Form.Control
        className={style.dataOverride}
        disabled={props.disabled}
        readOnly
        value={props.value}
        ref={dateRef}
        onFocus={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (dateRef.current){
              dateRef.current.classList.add(style.get)
          }
        }}
        onBlur={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        placeholder={props.placeholder}
      />
      <Calendar
        className={style.calendar}
        inputRef={dateRef}
        onChange={props.onChange}
        maxDetail={props.maxDetail}
        minDate={props.minDate}
        maxDate={props.maxDate}
      />
    </div>
  )
}


interface DateControlProps{
    value?: string,
    onChange?: Function,
    maxDetail?: 'month' | 'year' | 'decade' | 'century',
    placeholder?: string,
    minDate?: Date,
    maxDate?: Date,
    disabled?: boolean
}
